import "styles/PageLayout.css";

import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { ConfigProvider, Layout, theme } from "antd";

import SideMenuBar from "components/Menu/SideMenuBar";
import TopMenuBar from "components/Menu/TopMenuBar";

const { Header, Sider, Content } = Layout;

const PageLayout = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [collapseSideMenu, setCollapseSideMenu] = useState(false);
  const [contentMarginLeft, setContentMarginLeft] = useState(
    collapseSideMenu ? "80px" : "200px"
  );

  useEffect(() => {
    setContentMarginLeft(collapseSideMenu ? "80px" : "200px");
  }, [collapseSideMenu]);

  return (
    <>
      <Layout className="page-layout">
        <ConfigProvider
          theme={{
            algorithm: theme.darkAlgorithm,
            token: {
              colorBgBase: "#0C2055",
            },
            components: {
              Menu: {
                itemBg: "#0C2055",
                itemSelectedBg: "#1677ff",
                itemSelectedColor: "#FFF",
              },
            },
          }}
        >
          <Sider
            className="sider"
            collapsed={collapseSideMenu}
            onCollapse={setCollapseSideMenu}
            collapsible={true}
          >
            <SideMenuBar collapsed={collapseSideMenu} />
          </Sider>
        </ConfigProvider>
        <Layout className="right-page-layout">
          <Header
            className="header"
            style={{
              background: colorBgContainer,
            }}
          >
            <div style={{ marginLeft: contentMarginLeft }}>
              <TopMenuBar />
            </div>
          </Header>

          <Content
            className="content"
            style={{ marginLeft: contentMarginLeft }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default PageLayout;
